import { ALLOWED_PARENT_ORIGINS } from '../constants';
import { IMessagePayload } from '../types';

/**
 * function to post message to parent window
 * @param type message type string
 * @param data message payload to be sent
 */
export const postMessageToParent = (
  type: IMessagePayload['type'],
  data: IMessagePayload['data']
) => {
  if (window.parent !== window) {
    ALLOWED_PARENT_ORIGINS.forEach((origin) => {
      try {
        postMessage(type, data, window.parent, origin);
      } catch (e) {
        console.log(e, origin);
      }
    });
  }
};

/**
 * function to post message to parent or child iframe window
 * @param type message type string
 * @param data message payload to be sent
 * @param iframe if null, post message to parent window
 * @param origin origin of the parent window
 */
export const postMessage = (
  type: IMessagePayload['type'],
  data: IMessagePayload['data'],
  iframe: HTMLIFrameElement | null | Window,
  origin?: string
) => {
  const payload = {
    type,
    data,
  };
  const message = JSON.stringify(payload);

  if (iframe instanceof HTMLIFrameElement) {
    iframe?.contentWindow?.postMessage?.(message, iframe.src);
  } else if (iframe != null && origin) {
    iframe.postMessage?.(message, origin);
  }
};
